/* eslint-disable object-curly-newline */
/**
 * Auto injected components Imports
 * ↓ please keep comments (starting with `// ===`) to keep the auto insertion working
 */
// === Imports ===
import ProfileNav from './organisms/profile-nav/profile-nav';
import ProfileSubmenu from './molecules/profile-submenu/profile-submenu';
import Accordeon from './1-javascript/accordeon/accordeon';
import InitialAppearance from './1-javascript/initial-appearance/initial-appearance';
import ScrollIndicator from './atoms/scroll-indicator/scroll-indicator';
import Button from './atoms/button/button';
import Breadcrumbs from './molecules/breadcrumbs/breadcrumbs';
import Toolbox from './molecules/toolbox/toolbox';
import FaqCategory from './molecules/faq-category/faq-category';
import Video from './molecules/video/video';
import ArticleList from './organisms/article-list/article-list';
import ArticleListProfile from './organisms/article-list/article-list--profile';
import Form from './organisms/form/form';
import Header from './organisms/header/header';
import Modal from './organisms/modal/modal';
import Navigation from './organisms/navigation/navigation';
import ResultListProfile from './organisms/result-list/result-list--profile';
import SectionProfileBio from './organisms/section-profile-bio/section-profile-bio';
import WeeklySchedule from './organisms/weekly-schedule/weekly-schedule';
import SectionCardResearch from './organisms/section-card-research/section-card-research';
import Gallery from './wp-blocks/gallery/gallery';
import PageAnnuaire from './templates/09-page-annuaire/page-annuaire';
import PageProjectList from './templates/10-page-project-list/page-project-list';

// === Loader Object ===
export default [
	{ view: Accordeon, name: 'Accordeon', selector: '[data-accordeon]' },
	{ view: ScrollIndicator, name: 'ScrollIndicator', selector: '[data-scroll-indicator]' },
	{ view: InitialAppearance, name: 'InitialAppearance', selector: '.initial-appearance' },
	{ view: Breadcrumbs, name: 'Breadcrumbs', selector: '[data-breadcrumbs]' },
	{ view: Button, name: 'Button', selector: '[data-button]' },
	{ view: Form, name: 'Form', selector: '[data-form]' },
	{ view: Modal, name: 'Modal', selector: '[data-modal]' },
	{ view: Navigation, name: 'Navigation', selector: '[data-navigation]', global: true },
	{ view: Toolbox, name: 'Toolbox', selector: '[data-toolbox]' },
	{ view: FaqCategory, name: 'FaqCategory', selector: '[data-faq-category]' },
	{ view: ArticleList, name: 'ArticleList', selector: '[data-article-list]' },
	{ view: ArticleListProfile, name: 'ArticleListProfile', selector: '[data-article-list-profile]' },
	{ view: WeeklySchedule, name: 'WeeklySchedule', selector: '[data-weekly-schedule]' },
	{ view: Header, name: 'Header', selector: '[data-header]' },
	{ view: Video, name: 'Video', selector: '[data-video]' },
	{ view: ResultListProfile, name: 'ResultListProfile', selector: '[data-result-list-profile]' },
	{ view: ProfileSubmenu, name: 'ProfileSubmenu', selector: '[data-profile-submenu]' },
	{ view: ProfileNav, name: 'ProfileNav', selector: '[data-profile-nav]' },
	{ view: SectionProfileBio, name: 'SectionProfileBio', selector: '[data-section-profile-bio]' },
	{ view: SectionCardResearch, name: 'SectionCardResearch', selector: '[data-section-card-research]' },
	{ view: Gallery, name: 'Gallery', selector: '[data-gallery]' },
	{ view: PageAnnuaire, name: 'PageAnnuaire', selector: '[data-page-annuaire]' },
	{ view: PageProjectList, name: 'PageProjectList', selector: '[data-page-project-list]' },
];
